import Button from 'react-bootstrap/Button'
import Masonry from 'react-masonry-css'

import CardHover from '@/components/CardHover/CardHover'
import Spinner from '@/components/Spinner/Spinner'
import { fetchMore } from '@/store/cardlists/actions/fetchMore'
import { useAppSelector } from '@/store/hooks'
import { CardListType } from '@/types/page'

import styles from './TextView.module.scss'

type Props = {
  cardLists: CardListType[]
}

const TextView = ({ cardLists }: Props) => {
  const loading = useAppSelector((state) => state.cardlists.loading)
  return (
    <div className={styles.text}>
      <Masonry
        breakpointCols={{
          1600: 3,
          576: 1,
          992: 2,
          default: 3,
        }}
        className={styles.myMasonryGrid}
        columnClassName={styles.myMasonryGridColumn}
      >
        {cardLists
          ?.filter((cardlist) => cardlist.cardviews.length > 0)
          .map((cardlist, i) => (
            <div className={styles.textSection} id={cardlist.tag} key={cardlist.tag}>
              {cardLists.length > 1 && (
                <h3 className={styles.textHeader}>
                  {cardlist.header} ({cardlist.cardviews.length})
                </h3>
              )}
              <div className='d-flex flex-column'>
                {cardlist.cardviews.map((cardview, i) => (
                  <CardHover key={i} card={cardview} />
                ))}
              </div>
              {cardlist.more && (
                <span>
                  <br />
                  <Button disabled={loading} onClick={() => fetchMore(i)}>
                    {loading ? <Spinner /> : 'Load More'}
                  </Button>
                </span>
              )}
            </div>
          ))}
      </Masonry>
    </div>
  )
}

export default TextView
